import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { MiniNav } from './FieldComponents';
import { useNavVariant } from '../App';
import { Billing } from './Billing';
import '../styles/FirmSettings.css';
import { BillingSetup } from './BillingSetup';
import { CustomFields } from './Customs';
import { LayoutEditor } from './LayoutEditor';
import UserManagement from './UserManagement';
import { Tasks } from './Tasks';
import TeamAssignmentReplacement from './TeamAssignmentReplacement';

const FirmSettings = () => {
    const [page, setPage] = useState(0);
    const navVariant = useNavVariant();
    const navigate = useNavigate();
    const { pageIndex } = useParams();
    const containerRef = useRef(null);

    useEffect(() => {
        document.title = 'Firm Settings | CaseDB';
    }, []);

    useEffect(() => {
        if (pageIndex === undefined) {
            navigate('/firm-settings/0', { replace: true });
            return;
        }

        const parsed = Number(pageIndex);
        if (!Number.isFinite(parsed)) {
            setPage(0);
            return;
        }

        const clamped = Math.max(0, Math.min(parsed, 6));
        setPage(clamped);
    }, [pageIndex, navigate]);

    useEffect(() => {
        const firmSettingsContainer = containerRef.current;
        const firmContainer = firmSettingsContainer?.querySelector('.firm-container');
        if (!firmContainer) return;

        const updateHeaderScrollState = () => {
            const headers = firmSettingsContainer.querySelectorAll('#page-header');
            headers.forEach(header => {
                if (firmContainer.scrollTop > 0) {
                    header.classList.add('scrolled');
                } else {
                    header.classList.remove('scrolled');
                }
            });
        };

        updateHeaderScrollState();
        firmContainer.addEventListener('scroll', updateHeaderScrollState, { passive: true });

        return () => {
            const headers = firmSettingsContainer.querySelectorAll('#page-header');
            headers.forEach(header => header.classList.remove('scrolled'));
            firmContainer.removeEventListener('scroll', updateHeaderScrollState);
        };
    }, [page]);

    function renderPage() {
        switch (page) {
            case 0:
                return <Billing />;
            case 1:
                return <BillingSetup />;
            case 2:
                return <CustomFields />;
            case 3:
                return <LayoutEditor />;
            case 4:
                return <UserManagement />;
            case 5:
                return <Tasks />;
            case 6:
                return <TeamAssignmentReplacement />;
            default:
                return <Billing />;
        }
    }

    return (
        <div className={`page-container firm-settings-page ${navVariant === 'full' ? 'ab' : navVariant === 'compact' ? 'compact' : 'nav-overlay'}`}>
            <div className='firm-settings-container' ref={containerRef}>
                <MiniNav options={['Billing', 'Billing Setup', 'Custom Fields', 'Layout Editor', 'User Management', 'Task Workflow', 'Team Reassignment']} selectedOption={page} setSelectedOption={(nextPage) => {
                    setPage(nextPage);
                    navigate(`/firm-settings/${nextPage}`);
                }} />
                {renderPage()}
            </div>
        </div>
    );
}

export default FirmSettings;
